export default class ThankYouModal {
    options = {
        closeOnBackdrop: false,
        closeOnEscape: false,
    }
    constructor(element, options = {}) {
        this.element = element;
        this.options = { ...this.options, ...options };
        this.closeButton = this.element.querySelector('.icore-eventsbyrsquare-thankyou-popup-modal__close-btn');
        this.backdrop = this.element.querySelector('.icore-eventsbyrsquare-thankyou-popup-modal__backdrop');
        this.modal = this.element.querySelector('.icore-eventsbyrsquare-thankyou-popup-modal');

        this.#setupEventListeners();
    }

    show() {
        if ( this.modal && this.backdrop ) {
            this.modal.classList.add('icore-eventsbyrsquare-thankyou-popup--active');
            this.backdrop.classList.add('backdrop--isActive');
            document.body.classList.add('icore-eventsbyrsquare-thankyou-popup--is-active');
            if ( window.$iCore.lenis ) {
                window.$iCore.actions.destroyLenis();
            }
        }
    }

    hide() {
        if ( this.modal && this.backdrop ) {
            this.modal.classList.remove('icore-eventsbyrsquare-thankyou-popup--active');
            this.backdrop.classList.remove('backdrop--isActive');
            document.body.classList.remove('icore-eventsbyrsquare-thankyou-popup--is-active');
            if ( !window.$iCore.lenis ) {
                window.$iCore.actions.initializeLenis();
            }
        }
    }

    #setupEventListeners() {
        if ( this.closeButton ) {
            this.closeButton.addEventListener('click', this.hide.bind(this));
        }

        if ( this.backdrop && this.options.closeOnBackdrop ) {
            this.backdrop.addEventListener('click', this.hide.bind(this));
        }

        if ( this.options.closeOnEscape ) {
            document.addEventListener('keydown', (evt) => {
                if ( evt.key === 'Escape' ) {
                    this.hide();
                }
            });
        }

        const triggers = document.querySelectorAll('.icore-eventsbyrsquare-thankyou-modal-trigger');
        if ( triggers.length ) {
            triggers.forEach( trigger => {
                trigger.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.show();
                });
            });
        }
    }
}